const MAIN_BUNDLE_PATTERN = /\/static\/js\/main\.[^/]+\.js$/;

const normalizePath = (path) => {
  if (!path) return null;

  try {
    return new URL(path, window.location.origin).pathname;
  } catch (error) {
    return null;
  }
};

export const getLoadedMainBundlePath = (documentRef = document) => {
  const script = Array.from(documentRef.scripts).find((candidate) => {
    const path = normalizePath(candidate.src);
    return path && MAIN_BUNDLE_PATTERN.test(path);
  });

  return script ? normalizePath(script.src) : null;
};

export const getLatestMainBundlePath = (manifest) => {
  const mainBundle = manifest?.files?.['main.js'];
  const path = normalizePath(mainBundle);

  return path && MAIN_BUNDLE_PATTERN.test(path) ? path : null;
};
